// Packages
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { X } from "@phosphor-icons/react";

import {
  fetchDataPayment,
  removePromotionCoupon,
} from "../actions/checkoutStore";
import { GiftCards } from "./GiftCards";

const OrderSummary = (props) => {
  const { type = "" } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { summary, shipping, information } = useSelector(
    (state) => state.checkoutStore,
  );

  const removePromotion = (code) => {
    dispatch(removePromotionCoupon(code));
    dispatch(fetchDataPayment());
  };

  const checkShippingAboveZero = () => {
    return (
      information.shipping_option === "delivery" &&
      !information.no_shipping_required &&
      summary.shipping != null &&
      summary.shipping !== "" &&
      shipping.shipping_names.shipping_method_name !== null
    );
  };

  const AdditionalData = (
    <div className="mt-2">
      {!information.no_shipping_required &&
        props.type != "success" &&
        (!checkShippingAboveZero() ? null : (
          <div className="separatedContent">
            <span className="span-font-14 text-nowrap my-auto fw-semibold">
              {t("summary.shipping-cost")}
            </span>
            <div className="d-flex justify-content-end">
              <span className="span-font-14 d-flex justify-content-end flex-wrap">
                {summary.promotions.map((promotion) => {
                  return promotion.code != null &&
                    promotion.discount_target == "shipping" ? (
                    <span
                      className="span-font-14 badge text-bg-primary bg-white badge-coupons v2-promotion-codes"
                      key={promotion.id}
                      id={"promotion_" + promotion.id}
                    >
                      {promotion.code}&nbsp;
                      {type !== "success" && (
                        <a
                          href="#"
                          onClick={() =>
                            removePromotion(encodeURIComponent(promotion.code))
                          }
                        >
                          <X className="fas" size={24} weight="bold" />
                        </a>
                      )}
                    </span>
                  ) : null;
                })}
              </span>
              {information.shipping_option === "store_pickup" ? (
                shipping.pickup_point_name != null ? (
                  t("summary.pick-up-on") + shipping.pickup_point_name
                ) : (
                  t("summary.local-pickup")
                )
              ) : summary.shipping != null &&
                summary.shipping !== "" &&
                !summary.cash_on_delivery ? (
                summary.shipping_discount != summary.shipping ? (
                  <b className="d-inline-block span-font-14 text-wrap text-end ps-2">
                    <s className="span-font-14 ps-2">
                      {summary.raw_shipping === 0
                        ? t("summary.free-shipping")
                        : summary.shipping}
                    </s>{" "}
                    {summary.shipping_discount}
                  </b>
                ) : (
                  <b className="span-font-14">
                    {summary.raw_shipping === 0
                      ? t("summary.free-shipping")
                      : summary.shipping_discount}
                  </b>
                )
              ) : !summary.cash_on_delivery ? (
                t("summary.calculated-next-step")
              ) : (
                summary.shipping
              )}
            </div>
          </div>
        ))}
      {!information.no_shipping_required &&
        props.type == "success" &&
        (!checkShippingAboveZero() ? null : (
          <div className="row g-0 mb-2 fw-semibold">
            <span className="col-sm-3">{t("summary.shipping-cost")}</span>
            <div className="col-sm-9 d-inline-flex align-items-center">
              <div className="pe-2">
                {summary.promotions.map((promotion) => {
                  return promotion.code != null &&
                    promotion.discount_target == "shipping" ? (
                    <span
                      className="span-font-14 badge text-bg-primary bg-white badge-coupons v2-promotion-codes"
                      key={promotion.id}
                      id={"promotion_" + promotion.id}
                    >
                      {promotion.code}&nbsp;
                      {type !== "success" && (
                        <a
                          href="#"
                          onClick={() =>
                            removePromotion(encodeURIComponent(promotion.code))
                          }
                        >
                          <X className="fas" size={24} weight="light" />
                        </a>
                      )}
                    </span>
                  ) : null;
                })}
              </div>
              {information.shipping_option === "store_pickup" ? (
                shipping.pickup_point_name != null ? (
                  t("summary.pick-up-on") + shipping.pickup_point_name
                ) : (
                  t("summary.local-pickup")
                )
              ) : summary.shipping != null && summary.shipping !== "" ? (
                summary.shipping_discount != summary.shipping ? (
                  <b className="d-inline-block span-font-14 text-wrap text-end">
                    <s className="span-font-14">
                      {summary.raw_shipping === 0
                        ? t("summary.free-shipping")
                        : summary.shipping}
                    </s>{" "}
                    {summary.shipping_discount}
                  </b>
                ) : (
                  <b className="span-font-14">
                    {summary.raw_shipping === 0
                      ? t("summary.free-shipping")
                      : summary.shipping_discount}
                  </b>
                )
              ) : (
                t("summary.calculated-next-step")
              )}
            </div>
          </div>
        ))}
      {summary.raw_tax > 0 && (
        <div className="separatedContent" id="summary_tax">
          <span className="span-font-14 fw-semibold">{t("summary.taxes")}</span>
          <b className="span-font-14">{summary.tax}</b>
        </div>
      )}
      <GiftCards allowRemoval />
    </div>
  );

  const Total = (
    <div className="mt-2 summary-div">
      {props.type != "success" && (
        <>
          {summary.gift_cards?.length > 0 ? (
            <div className="separatedContent ">
              <b>{t("summary.amount-due")}</b>
              <b>{summary.total_outstanding}</b>
            </div>
          ) : (
            <div className="separatedContent ">
              <b>{t("summary.total")}</b>
              <b>{summary.total}</b>
            </div>
          )}
        </>
      )}
      {props.type === "success" && (
        <>
          {summary.gift_cards?.length > 0 ? (
            <div className="row g-0 mb-2">
              <div className="col-sm-3">{t("summary.paid-amount")}</div>
              <div className="col-sm-9">
                {summary.total_outstanding_success_page}
              </div>
            </div>
          ) : (
            <div className="row g-0 mb-2">
              <div className="col-sm-3">{t("summary.total")}</div>
              <div className="col-sm-9">{summary.total}</div>
            </div>
          )}
        </>
      )}
    </div>
  );

  return (
    <Fragment>
      <div className="mt-3">
        {props.type == "success" && (
          <div className="row g-0 mb-2">
            <span className="col-sm-3 fw-semibold">
              {t("summary.subtotal")}
            </span>
            <div className="col-sm-9 d-inline-flex align-items-center">
              {summary.promotions.map((promotion) => {
                return promotion.code != null &&
                  promotion.discount_target != "shipping" ? (
                  <div className="pe-2">
                    <span
                      className="span-font-14 badge text-bg-primary bg-white badge-coupons v2-promotion-codes"
                      key={promotion.id}
                      id={"promotion_" + promotion.id}
                    >
                      {promotion.code}&nbsp;
                      {type !== "success" && (
                        <a
                          href="#"
                          onClick={() =>
                            removePromotion(encodeURIComponent(promotion.code))
                          }
                        >
                          <X className="fas" size={24} weight="light" />
                        </a>
                      )}
                    </span>
                  </div>
                ) : null;
              })}

              <b className="d-inline-block span-font-14 text-wrap text-end">
                {summary.subtotal_discount != summary.subtotal && (
                  <s>{summary.subtotal}</s>
                )}{" "}
                {summary.subtotal_discount}
              </b>
            </div>
          </div>
        )}
        {props.type != "success" && (
          <div className="separatedContent ">
            <span className="span-font-14 text-nowrap my-auto fw-semibold">
              {t("summary.subtotal")}
            </span>
            <div className="d-flex justify-content-end align-items-end">
              <div className="span-font-14 d-flex justify-content-end flex-wrap">
                {summary.promotions.map((promotion) => {
                  return promotion.code != null &&
                    promotion.discount_target != "shipping" ? (
                    <span
                      className="span-font-14 badge text-bg-primary bg-white badge-coupons v2-promotion-codes"
                      key={promotion.id}
                      id={"promotion_" + promotion.id}
                    >
                      {promotion.code}&nbsp;
                      {type !== "success" && (
                        <a
                          href="#"
                          onClick={() =>
                            removePromotion(encodeURIComponent(promotion.code))
                          }
                        >
                          <X className="fas" size={24} weight="light" />
                        </a>
                      )}
                    </span>
                  ) : null;
                })}
              </div>
              <span className="d-inline-block span-font-14 text-wrap text-end ps-2">
                {summary.subtotal_discount != summary.subtotal && (
                  <s>{summary.subtotal}</s>
                )}{" "}
                {summary.subtotal_discount}
              </span>
            </div>
          </div>
        )}
      </div>
      {(summary.subtotal != summary.total ||
        checkShippingAboveZero() ||
        summary.raw_tax > 0 ||
        (summary.has_promotions_with_code && summary.promotions?.length > 0) ||
        summary.raw_discount > 0 ||
        summary.gift_cards?.length > 0) &&
        AdditionalData}
      {Total}
    </Fragment>
  );
};
export default OrderSummary;
